import { Dispatch, SetStateAction } from 'react'
import {
  Meta,
  WappMode,
  WappInput,
  CustomAction,
} from '@weblite-wapps/protocol'

export enum WappParentType {
  WAPP = 'wapp',
  NON_WAPP = 'non-wapp',
}

// eslint-disable-next-line no-shadow
export enum WappCondition {
  RUN_WAPP = 'run-wapp',
  RECEIVE_MESSAGE = 'receive-message',
  SHOW_LOADING = 'show-loading',
}

// eslint-disable-next-line no-shadow
export enum WappStage {
  LOADING = 'loading',
  RUNNING = 'running',
}

export type WappParent =
  | (Meta & {
      type: WappParentType.WAPP
    })
  | { type: WappParentType.NON_WAPP; resolverId: string }

export class WappSessionCreator {
  wappSessionId?: string
  wappId: string
  wisId?: string
  mode: WappMode
  input?: WappInput
  parent?: WappParent
  hideHeader?: boolean
  updateWappSessionId?: Dispatch<SetStateAction<string>>
}

export interface BookmarkData {
  contentUri: string
  cover: string
}

export class WappSession extends WappSessionCreator {
  wappSessionId: string
  elementName: string
  output?: unknown
  stage: WappStage
  servIndexes: Record<WappMode, string>
  customActions?: CustomAction[]
  bookmarkData?: BookmarkData
}
